var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.img)?_c('cropper',{staticClass:"cropper",attrs:{"src":_vm.img,"stencil-props":{
        aspectRatio: 2/3
    }},on:{"change":_vm.change}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }